import {
  UpdateInstallableDefinitionMutation,
  UpdateInstallableDefinitionMutationVariables
} from './__generated__/UpdateInstallableDefinitionMutation'
import {
  UpdateInstallableMutation,
  UpdateInstallableMutationVariables
} from './__generated__/UpdateInstallableMutation'
import { UpdateInstallableV2, UpdateInstallableV2Variables } from './__generated__/UpdateInstallableV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateInstallableMutation($input: UpdateInstallableInput!) {
    updateInstallable(input: $input) {
      id
    }
  }
`

const MUTATION_V2 = gql`
  mutation UpdateInstallableV2($input: UpdateInstallableInputV2!) {
    updateInstallableV2(input: $input) {
      ... on InstallableErrorV2 {
        type
        error
      }
      ... on InstallableV2 {
        id
      }
    }
  }
`

const DEFINITION_MUTATION = gql`
  mutation UpdateInstallableDefinitionMutation($input: UpdateInstallableDefinitionInputV2!) {
    updateInstallableDefinitionV2(input: $input) {
      ... on InstallableDefinitionV2 {
        installableId
        definitionJson
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`

export const useUpdateInstallable = () => {
  return useMutation<UpdateInstallableMutation, UpdateInstallableMutationVariables>(MUTATION)
}

export const useUpdateInstallableDefinition = () => {
  return useMutation<UpdateInstallableDefinitionMutation, UpdateInstallableDefinitionMutationVariables>(
    DEFINITION_MUTATION
  )
}
export const useUpdateInstallableV2 = () => {
  return useMutation<UpdateInstallableV2, UpdateInstallableV2Variables>(MUTATION_V2)
}
